import { Component } from '@angular/core'
import { PwaService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { PwaPromoBannerComponent } from '../../../components/basic/pwa-promo-banner/pwa-promo-banner.component'
import { FooterContainerComponent } from '../../../components/basic/footer-container/footer-container.component'
import { RevolutionArticlesComponent } from '../../../components/revolution/revolution-articles/revolution-articles.component'
import { RevolutionServicesComponent } from '../../../components/revolution/services/services.component'
import { NavbarComponent } from '../../../components/revolution/navigation/navbar/navbar.component'
import { NavbarSecondComponent } from '../../../components/revolution/navigation/navbar-second/navbar-second.component'
import { RevolutionVehicleListComponent } from '../../../components/revolution/content/revolution-vehicle-list/revolution-vehicle-list.component'
import { SupportCardComponent } from '../../../components/revolution/content/support-card/support-card.component'
import { UserNoticeCardComponent } from '../../../components/revolution/content/user-notice-card/user-notice-card.component'
import { HeroComponent } from '../../../components/revolution/content/hero/hero.component'
import { NotificationsPanelComponent } from '../../../components/revolution/content/notifications-panel/notifications-panel.component'
@Component({
  selector: 'customer-portal-app-summary',
  standalone: true,
  templateUrl: './summary.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    PwaPromoBannerComponent,
    FooterContainerComponent,
    RevolutionArticlesComponent,
    RevolutionServicesComponent,
    NavbarComponent,
    NavbarSecondComponent,
    RevolutionVehicleListComponent,
    SupportCardComponent,
    UserNoticeCardComponent,
    HeroComponent,
    NotificationsPanelComponent
  ]
})
export class SummaryComponent {
  isMobile = false
  isPwa = false
  isIos = false
  hasInstallPrompt = false
  isInstallable = false
  constructor (
    private readonly pwaService: PwaService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.hasInstallPrompt = Boolean(window['installPrompt'])
    this.isMobile = this.pwaService.checkMobile()
    this.isPwa = this.pwaService.checkPwa()
    this.isIos = this.pwaService.checkIos()
    this.isInstallable =
      this.hasInstallPrompt && this.isMobile && !this.isPwa && !this.isIos
    this.hasNewFooter = this.remoteConfigService.get('hasNewFooter')
    this.showPwaPromoBanner = this.remoteConfigService.get('pwaEnabled')
    this.showDashEcoNews = this.remoteConfigService.get('showDashEcoNews')
    this.showServices = this.remoteConfigService.get(
      'additionalServices.visibleOnHomepage'
    )
  }

  public showPwaPromoBanner
  showDashEcoNews
  showServices
  public hasNewFooter
  hidePwaPromoBanner (): void {
    this.showPwaPromoBanner = false
  }
}
